module.exports = __webpack_public_path__ + "static/media/qodo-flat.840569b0.svg";